import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { REGISTER, LOGIN, PROFILEVIEW } from 'src/app/config';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    
})
export class RegisterComponent implements OnInit {
  sign:boolean=true;
  loading:boolean=false;
  otpcheck: boolean;
  message:any;
  alert:boolean;
  type="Customer/Retailer";
  mobile_no:any;
  mobile:any=true;
  mob:boolean;
  pan_check: boolean;
  adhar_check: boolean;
  gst_check: boolean;
  
  constructor(private api:ApiService,private router:Router) { }

  changeGst(e)
  {
    
    if(e.length==0)
    {
        this.gst_check=false;
    }
    else if(e.length==15)
    {
      var pattern = new RegExp("([0]{1}[1-9]{1}|[1-2]{1}[0-9]{1}|[3]{1}[0-7]{1})([a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9a-zA-Z]{1}[zZ]{1}[0-9a-zA-Z]{1})");
      if(pattern.test(e)){
        this.gst_check=false;
        console.log(true);
      }
      else{
        this.gst_check=true;
      }
      
    }
    else{
      this.gst_check=true;
    }
  }
  changeAadhar(e)
  {
    
  
    console.log(e.length);
    if(e.length==0)
    {
        this.adhar_check=false;
    }
    else if(e.length==14)
    {
      
      var pattern = new RegExp("\\d{4}\\s\\d{4}\\s\\d{4}");
      if(pattern.test(e)){
        this.adhar_check=false;
        console.log(true);
      }
      else{
        this.adhar_check=true;
      }
     
    }
    else{
      this.adhar_check=true;
    }
  }
  changePan(e)
  {
     
    if(e.length==0)
    {
        this.pan_check=false;
    }
    else if(e.length==10)
    {
      var pattern = new RegExp("[A-Z]{5}[0-9]{4}[A-Z]{1}");
      if(pattern.test(e))
      {
        this.pan_check=false;
        console.log("true");
      }
      else{
        this.pan_check=true;
      }
     
    }
    else{
      this.pan_check=true;
    }
  }



    changeNumber(e)
    {
      let t =new String(e);
      // console.log(t.length);
      // console.log(t);
      if(t.length==0||t=="null")
      {
        this.mob=false;
      }
      else if(t.length==10)
      {
        this.mob=false;
    //   console.log("perfect");
      }
      else{
        this.mob=true;
      //  console.log("imperfect");
      }
    }
    SignUp(value) {
      
        if(this.type =="Customer/Retailer"){
        this.loading=true;
        this.sign=false;
          if(value.name&&value.email&&value.mobile_no&&this.type)
          {
              this.mobile_no=value.mobile_no;
              
                this.api.Post(REGISTER,{name:value.name,mobile_no:value.mobile_no,email:value.email,user_type:this.type}).then(data=>{
                  this.mobile=false;
                  this.loading=false;
                  this.otpcheck=true;
                  console.log(data);
                }).catch(d=>{
                  console.log(d);
                  this.loading=false;
                  this.message="Something Went Wrong Please Try Again";
                  this.alert=true;
                  this.sign=true;
                });
          }
          else if(value.password)
        {
            this.loading=true;
            this.otpcheck=false;
            this.login(value.password);
        }    
      }else if(this.type == 'Dealer/wholesaler' ){
        this.loading=true;
        this.sign=false;
        if(value.name&&value.email&&value.mobile_no&&this.type&&value.pan_no&&value.gst_no&&value.Aadhar)
          {
            
              this.mobile_no=value.mobile_no;
                this.api.Post(REGISTER,{name:value.name,mobile_no:value.mobile_no,email:value.email,user_type:this.type,pan_no:value.pan_no,gst_no:value.gst_no,aadhar:value.Aadhar}).then(data=>{
                  this.mobile=false;
                  this.loading=false;
                  this.otpcheck=true;
                  console.log(data);
                }).catch(d=>{
                  console.log(d);
                  this.loading=false;
                  this.message="Something Went Wrong Please Try Again";
                  this.alert=true;
                  this.sign=true;
                });
          }
          else if(value.password)
        {
            this.loading=true;
            this.otpcheck=false;
            this.login(value.password);
        }  
      }
      else{
        this.api.onFail('Please Choose User Type','No User Type');
      }
    }
    login(otpvalue)
  {
  
    
        this.api.Post(LOGIN,{mobile_no:this.mobile_no, otp:otpvalue,one_singnal:11}).then(data=>{
        this.loading=false;
          console.log(data['success'].token);
          this.api.setMobileNo(data['success'].token);
          this.api.setlogin(1);
          if(this.api.goto){
            this.api.getGoto();
          } else {
           this.router.navigate(['/home']);}
        }).catch(d=>{
          console.log(d);
          this.loading=false;
          this.message="INVALID OTP";
          this.alert=true;
          this.otpcheck=true;
        });
    }
    user(value) {
        this.type = value;
    }

    ngOnInit() {
      this.api.getlogin.subscribe(data=>{
        if(this.api.drop==1)
        {
          this.api.Post(PROFILEVIEW, {}).then(data=>{
            console.log(data);
            this.api.setUserInfo(data['user']);
          //    this.api.updateWishlist();
          // this.api.updateCart();
          if(localStorage.getItem('savya_userInfo'))
          {
            this.api.updateCart();
            this.api.updateWishlist();
            this.api.updateOrderHistory();
          }
            }).catch(d=>{
              if( d.status == 503){
                this.api.onFail('Your session is expired please login again','Login Again');
                this.api.setGoto();
                this.api.setlogin(0);
                this.api.logout();
                setTimeout(() => {
                this.router.navigate(['/login']);
                },1000);
              } else{
                console.log(d);
              }
            });
         
          console.log("login emitter");
        }
        if(this.api.drop==0)
        {
          console.log("logout emitter");
        }
        
      })
    }

  }
  


